import {Component, OnInit, ViewChild, ElementRef, Renderer2, AfterViewChecked} from '@angular/core';
import {ListClaimsService} from "./services/list-claims.service";
import {DataTableDirective} from "angular-datatables";
import AjaxSettings = DataTables.AjaxSettings;
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import * as feather from "feather-icons";
import {ClaimDto} from "../../auto-generated-server-dtos/list-claims/claim-dto";
import {VinSearchComponent} from "../vin-search/vin-search.component";
import {DeleteClaimComponent} from "../delete-claim/delete-claim.component";
import {OidcSecurityService} from "angular-auth-oidc-client";
import * as bootstrap from 'bootstrap';

@Component({
  selector: 'app-claims-list',
  templateUrl: './claims-list.component.html',
  styleUrls: ['./claims-list.component.scss']
})

export class ClaimsListComponent implements OnInit, AfterViewChecked {
  @ViewChild(DataTableDirective, { static: false }) datatableElement!: DataTableDirective;
  @ViewChild('claimsDataTable', { static: false }) claimsDataTable!: ElementRef;

  dtOptions: DataTables.Settings = {};
  errorOccurred = false;
  claims: ClaimDto[] = [];
  noRepairCentreId = false;

  constructor(
    private listClaimsService: ListClaimsService,
    private ngbModal: NgbModal,
    private renderer: Renderer2,
    private oidcSecurityService: OidcSecurityService
  ) {
    this.oidcSecurityService.getUserData().subscribe((userData) => {
      this.noRepairCentreId = !userData || !userData.RepairCentreId;
    });
  }

  ngOnInit(): void {

    this.dtOptions = {
      dom: '<"row"<"col-md-6"i><"col-md-6"f>><"row"<"px-0"t>><"row"<"col-6 mt-2"l><"col-6"p>>',
      language: {
        info: 'Showing _START_ to _END_ of _TOTAL_ claims',
        infoEmpty: 'Showing 0 claims',
        infoFiltered: '<br>Filtered from _MAX_ total claims',
        zeroRecords: 'No matching claims found',
        lengthMenu: 'Show _MENU_ claims',
        loadingRecords: '<div class="d-flex center" style="width: 100%"><div class="spinner-border text-primary" style="margin: auto" role="status"><span class="sr-only">Loading...</span></div></div>',
      },
      lengthMenu: [
        [10, 25, 50, 100, -1],
        [10, 25, 50, 100, 'All']
      ],
      pageLength: 25,
      order: [[1, 'desc']],
      processing: true,
      stateSave: false,
      ajax: (ajaxSettings: AjaxSettings, callback) => {
        this.listClaimsService.listClaims
        (
          ajaxSettings, {}
        ).subscribe({
            next: (resp: ClaimDto[]) => {
              this.claims = resp;
              callback({
                  recordsTotal: resp.length,
                  recordsFiltered: resp.length,
                  data: this.claims
                }
              )

            },
            error: (err: any) => {
              this.errorOccurred = true;
            }
          }
        );
      },
      columns: [
        {
          title: '',
          data: 'isNoTimelyResponseFromRepairCentre',
          className: 'text-nowrap align-middle w-icon-1 py-0 pe-0',
          searchable: false,
          orderable: false,
          render: (data) => {
            if (data) {
              return `
                <span class="text-warning" ngbTooltip="No reply within 48 hours">
                  <svg class="feather" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M23.5,18.7L14.1,2.8c-1-1.6-3.3-1.6-4.3,0L.5,18.7c-1,1.7.3,3.7,2.1,3.7h18.8c1.9,0,3.1-2,2.1-3.7ZM11.1,6.6h1.9c.6,0,1,.5,1,1l-.4,6.9c0,.5-.5.9-1,.9h-1.1c-.5,0-1-.4-1-.9l-.4-6.9c0-.6.4-1,1-1ZM12,20.4c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2-.9,2-2,2Z"/>
                  </svg>
                </span>
              `;
            }
            return '';
          }
        }, {
          title: 'Date',
          data: 'createdDateTime',
          className: 'text-nowrap w-auto',
          render: (data, type, row) => {
            if (type === 'sort') {
              return data;
            } else {
              const date = new Date(data);
              const dateStr = date.toLocaleDateString("en-us", {weekday: "short", year: "numeric", month: "short", day: "numeric"});
              const timeStr = date.toLocaleTimeString("en-us", {hour12: true, hour: "numeric", minute: "2-digit"})
              return `<span class="text-nowrap">${dateStr}</span> <span class="text-nowrap">${timeStr}</span>`;
            }
          }
        }, {
          title: 'Customer',
          data: 'customerName',
          className: 'w-auto'
        }, {
          title: 'VIN',
          data: 'vin'
        }, {
          title: 'Vehicle',
          data: 'ymmt',
          className: 'w-auto'
        }, {
          title: 'Type',
          data: 'coverageType',
          render: (data, type, row) => {
            return data;
          }
        }, {
          title: 'Status',
          data: 'status',
          render: (data) => {
            let statusClass = '';
            switch (data.toLowerCase()) {
              case 'draft':
                statusClass = 'secondary';
                break;
              case 'submitted':
                statusClass = 'primary';
                break;
              case 'viewed':
                data = 'Submitted'
                statusClass = 'primary';
                break;
              case 'accepted':
              case 'pre-approved':
              case 'approved':
                statusClass = 'success';
                break;
              case 'rejected':
                statusClass = 'danger';
                break;
              case 'deleted':
                statusClass = 'black';
                break;
              default:
                statusClass = 'primary';
            }
            return `<span class="badge bg-${statusClass}">${data}</span>`;
          }
        }, {
          title: 'Messages',
          data: 'messageCount',
          className: 'text-center',
          render: (data, type, row) => {
            // TODO: claims list: new message badge
            // if there are any new messages, render message count and add a badge that says new (bg-primary)
            // if message count is 0, don't render anything
            return data === 0 ? '' : data;
          }
        }, {
          title: '',
          data: '',
          searchable: false,
          orderable: false,
          className: 'text-end text-nowrap align-middle py-0',
          render: (data, type, row) => {
            if (row.status === 'Draft') {
              return `<div class="d-flex">
                  <a class="btn btn-sm btn-outline-primary btn-bg-white rounded-2 flex-fill me-2" href="/claim/${row.claimId}"><i class="me-1" data-feather="edit-2"></i>Edit</a>
                  <button class="btn btn-sm btn-outline-danger btn-bg-white rounded-2 flex-fill" data-claim-id="${row.claimId}"><i class="me-1" data-feather="trash"></i>Delete</button>
                </div>`;
            } else {
              return `<a class="btn btn-sm btn-outline-primary btn-bg-white rounded-2 w-100" href="/claim/${row.claimId}"><i class="me-1" data-feather="eye"></i>View</a>`;
            }
          }
        }
      ],
      rowCallback: (row: Node, data: any[] | Object, index: number) => {
        let rowElement = row as HTMLElement;
        let deleteButton = rowElement.querySelector('button.btn-outline-danger') as HTMLElement;
        deleteButton?.removeAllListeners!('click');
        deleteButton?.addEventListener('click', () => {
          if (deleteButton?.dataset) {
            this.openDeleteClaimModal(parseInt(deleteButton.dataset.claimId!), rowElement);
          }
        });
        return row;
      },
      drawCallback: () =>{
        feather.replace();
        this.initializeTooltips();
      }
    };
  }

  openVinSearchModal() {
    this.ngbModal.open(VinSearchComponent, {size: 'lg'});
  }

  openDeleteClaimModal(claimId: number, rowElement: HTMLElement) {
    let modalRef = this.ngbModal.open(DeleteClaimComponent);
    modalRef.componentInstance.claim = this.claims.find(c => c.claimId === claimId);
    modalRef.componentInstance.deletedClaim.subscribe((deletedClaim: ClaimDto) => {
      this.claims = this.claims.filter(c => c.claimId !== deletedClaim.claimId);
      let table = $('#claimsTable').DataTable();
      table.row(rowElement).remove();
      table.draw();
    });
  }

  ngAfterViewChecked(): void {
    if(!this.noRepairCentreId) {
      this.initializeTooltips();
    }
  }

  initializeTooltips(): void {
    const elements = this.claimsDataTable.nativeElement.querySelectorAll('[ngbTooltip]');
    elements.forEach((element: HTMLElement) => {
      if (!element.hasAttribute('tooltip-initialized')) {
        const tooltipText = element.getAttribute('ngbTooltip');
        this.renderer.setAttribute(element, 'title', tooltipText!);
        new bootstrap.Tooltip(element, { offset: [0, 0]});
        this.renderer.setAttribute(element, 'tooltip-initialized', '');
      }
    });
  }

}
